import { render, staticRenderFns } from "./createform.vue?vue&type=template&id=1fbcd776&scoped=true&"
import script from "./createform.vue?vue&type=script&lang=js&"
export * from "./createform.vue?vue&type=script&lang=js&"
import style0 from "./createform.vue?vue&type=style&index=0&id=1fbcd776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbcd776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbcd776')) {
      api.createRecord('1fbcd776', component.options)
    } else {
      api.reload('1fbcd776', component.options)
    }
    module.hot.accept("./createform.vue?vue&type=template&id=1fbcd776&scoped=true&", function () {
      api.rerender('1fbcd776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createform/createform.vue"
export default component.exports